import {
  MessageWidgetConfigContextType,
  OrdinaryConfigContext,
  WidgetFormSubmissionWithWidget,
  OplShowAddressConfigContext,
  AutoAssignConfigContext,
  ContactEnquiryConfigContext,
  PredefinedMessageConfigContext
} from "@closerplatform/spinner-openapi";

export type WidgetConfigContext = WidgetFormSubmissionWithWidget["widgetConfig"];

export const isExplicitlySubmittableWidget = (config: WidgetConfigContext): boolean => {
  return (
    isOrdinaryConfigContext(config) ||
    isOplAddressConfigContext(config) ||
    isPredefinedMessageConfigContext(config) ||
    isContactEnquiryConfigContext(config)
  );
};

export const isOrdinaryConfigContext = (
  config: WidgetConfigContext
): config is OrdinaryConfigContext => {
  return config.type === undefined;
};
export const isOplAddressConfigContext = (
  config: WidgetConfigContext
): config is OplShowAddressConfigContext => {
  return config.type === MessageWidgetConfigContextType.OplShowAddressForm;
};
export const isAutoAssignConfigContext = (
  config: WidgetConfigContext
): config is AutoAssignConfigContext => {
  return config.type === MessageWidgetConfigContextType.AutoAssignForm;
};
export const isContactEnquiryConfigContext = (
  config: WidgetConfigContext
): config is ContactEnquiryConfigContext => {
  return config.type === MessageWidgetConfigContextType.ContactEnquiry;
};
export const isPredefinedMessageConfigContext = (
  config: WidgetConfigContext
): config is PredefinedMessageConfigContext => {
  return config.type === MessageWidgetConfigContextType.PredefinedMessageForm;
};
